import ProximaNova from '../fonts/ProximaNova/ProximaNova-Regular.woff';
import { isMobile } from "react-device-detect";

let palette = {
    colors: {
        active: '#debd1d',
        mainText: '#162946',
        secondaryText: '#808080',
        grey: '#f5f6f8',
        teal: '#80cbc4',
        lightgrey: '#f5f5f5',
    },
    primary: {
        light: '#3C70F1',
        main: '#3C70F1',
        dark: '#3C70F1',
        contrastText: '#ede7f6',
    },
    secondary: {
        light: '#ffecb3',
        main: '#3C70F1',
        dark: '#827017',
        contrastText: '#e0f7fa',
    },
}


const proxima = {
    fontFamily: 'ProximaNova',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('ProximaNova'),
      local('ProximaNova-Regular'),
      url(${ProximaNova}) format('woff')
    `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export default {
    palette,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [proxima],
            },
        },
        //#region select  
        MuiMenuItem: {
            root: {
                fontSize: 16,
                fontFamily: [proxima],
                '&$selected': {
                    backgroundColor: '#3C70F1',
                    color: '#fff'
                },
                '&:hover': {
                    backgroundColor: '#3C70F1',
                    color: '#fff'
                },
                '&:focus': {
                    backgroundColor: '#3C70F1',
                    color: '#fff'
                }

            }
        },
        MuiSelect: {
            root: {
                borderRadius: '10px',
                '&:hover': {
                    backgroundColor: '#fff',
                    borderRadius: '10px',

                },
                '&:focus': {
                    backgroundColor: '#fff',
                },

            },
            select: {
                '&:focus': {
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                },
            }
        },

        MuiFormControl: {
            root: {

                marginLeft: isMobile ? 20 : 63,
                minWidth: isMobile ? 335 : 309,
                maxWidth: isMobile ? 335 : 309,
                fontFamily: 'proxima',
                backgroundColor: '#fff',
                borderRadius: '10px',
            },
        },

        MuiInputLabel: {
            root: {
                marginTop: 10,
                paddingBottom: 5,
                fontSize: 16,

            }
        },

        MuiOutlinedInput: {
            root: {
                color: '#162946',
                borderRadius: '10px',
                fontFamily: 'proxima',
                '& fieldset': {
                    borderColor: '#fff',
                },

                "& $notchedOutline": {
                    borderColor: "#fff"
                },
                "&$focused $notchedOutline": {
                    borderColor: "#fff",
                },

                '&$disabled $notchedOutline': {
                    borderColor: "#fff",
                },
            },
        },
        MuiInputBase: {
            root: {

                backgroundColor: '##fff',
                fontFamily: 'proxima',
                fontWeight: 400,
            },
        },
        MuiFormLabel: {
            root: {
                fontFamily: 'proxima',
                fontSize: 14,
                marginTop: 0,
                color: '#16294680',
                "&$focused": {
                    color: "#16294680",
                },
            }
        },
        //#endregion
        //#region chipInput
        WAMuiChipInput: {
            root: {
                minWidth: 309,
                maxWidth: 309,
            },
            underline: {
                '&:before': {
                    content: null,
                }

            },
            labelShrink: {
                backgroundColor: 'transparent'
            }
        },

        MuiChip: {
            root: {
                minHeight: 28,
                maxHeight: 28,
                backgroundColor: '#E3EFFE',
                borderRadius: 5,
                fontfamily: 'proxima',
                marginTop: 5,
                marginLeft: 5,

            },
            deleteIcon: {
                order: 0,
                marginLeft: 10,
                marginRigth: 0,
                color: '#3C70F1',
            },
            label: {
                order: 1,
                marginLeft: -18,
                marginTop: 0,
                fontfamily: 'proxima',
            },
            labelSmall: {
                paddingLeft: 12,
            },
            labelMedium: {
                fontWeight: 600,
            }

        },
        //#endregion

        MuiAutocomplete: {
            inputRoot: {
                marginTop: 5
            },
            clearIndicator: {
                color: '#9FAABC',
                '&:hover': {
                    backgroundColor: '#ffffff00'
                }
            },
            popupIndicator: {
                '&:hover': {
                    backgroundColor: '#ffffff00'
                }
            }
        },
        MuiButton: {
            root: {
                fontSize: 16,
                fontFamily: 'proxima',
                fontWeight: 600
            },

        },
        
        MuiTouchRipple:{
            child: {
                // Some CSS
                backgroundColor: "#ffffff00"
              }
        },

        MuiCard: {
            root: {
                marginTop: 27,
                '&:hover': {
                    boxShadow: "0px 0px 20px rgba(60, 112, 241, 0.35)"
                },
            }

        },
        MuiPaper: {
            elevation1: {
                boxShadow: "1px 1px #E3EFFE"
            },
            elevation8: {
                boxShadow: "none",
                marginTop: -10,
                marginLeft: -1,
                border: '1px  solid #E3EFFE',
                borderTopRightRadius: 0,
                borderTopLeftRadius: 0,
                borderBottomRightRadius: 10,
                borderBottomLeftRadius: 10,
            }
        },

        MuiCardHeader: {
            root: {
                margin: 0,
                paddingTop: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingBottom: 0,
                maxHeight: 91,
                minHeight: 91,
            },
            avatar: {
                borderRadius: '10px',
                border: '1px solid #E3EFFE',
                maxHeight: 55,
                maxWidth: 55,
                minHeight: 55,
                minWidth: 55,
                marginTop: 0,
                marginLeft: 20,
                padding: 0,
            },
            content: {
                minHeight: 37
            },
            title: {
                width: 200,
                fontWeight: 600,
                marginTop: -6,
                textAlign: 'left',
                fontSize: 18,
                marginBottom: -20,
                padding: 0,
            },
            subheader: {
                width: 200,
                marginTop: 20,
                textAlign: 'left',
                fontWeight: 400,
            }
        },

        MuiCardContent: {
            root: {
                maxHeight: 105,
                minHeight: 110,
                padding: 0,
                marginTop: 12,
                marginLeft: 27,
            },
        },

        MuiAvatar: {
            square: {
                maxHeight: 55,
                maxWidth: 55,
                borderRadius: '10px',
            }
        },



        MuiTypography: {

            body1: {
                height: 52,
                width: 308,
                fontFamily: 'proxima',
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '26px',
                letterSpacing: '0em',
                textAlign: 'left',

            },
            body2: {
                fontFamily: 'proxima',
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 600,
                textAlign: 'center',
                minWidth: 200,

            },

            h3: {
                fontFamily: 'proxima',
                fontSize: 12,
                fontWeight: 400,
                lineHeight: 24,
            },
            h4: {
                fontFamily: 'proxima',
                fontSize: 20,
                fontStyle: 'normal',
                fontWeight: 'bold',
            },
            h5: {
                fontFamily: 'proxima',
                fontSize: 28,
                fontStyle: 'normal',
                fontWeight: 'bold',
            },
            h6: {
                fontFamily: 'proxima',
                fontSize: 16,
                fontStyle: 'normal',
            },
            caption: {
                fontFamily: 'proxima',
                fontSize: 16,
            },
        },
        MuiRadio: {
            root: {
                paddingLeft: 0,
            }
        }
    },
    typography: {
        fontFamily: ['proxima'],
    },

    tables: {
        tableHeader: {
            fontWeight: 'bold',
            fontSize: '1rem',
        },
    },
    mainStyles: {
        flexbox: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        flexboxAlign: {
            alignItems: 'center',
        },
        navbar: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: 100,
            height: '100%',
        },
        button: {
            margin: '20px 0 0 0',
            height: 50,
            fontSize: '1.1rem',
        },
        progress: {
            position: 'absolute',
        },
        titleBlock: {
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            color: 'white',
            textTransform: 'uppercase',
            paddingLeft: '2rem',
            fontSize: '2.5rem',
            fontWeight: '600',
            fontFamily: 'proxima',
        },
        buttonWrap: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 0',
        },
        mainWrap: {
            position: 'relative',
        },
    },
}

export const themeColors = {
    textColor: '#e6e6e6',
}
